import React from 'react';
import styled, { keyframes } from 'styled-components';

const slideInOverlay = keyframes`
  from {
    opacity : 0;
  }

  to {
    opacity: 1;
  }
`;

// animation: ${slideInModal} 0.2s ease-in 1;

const shadow = keyframes`50% {
  transform: scale(1.2,1);
}`;

const loader = keyframes` 0% { left: -100px }
100% { left: 110%; }`;

const animate = keyframes` 17% { border-bottom-right-radius: 3px; }
25% { transform: translateY(9px) rotate(22.5deg); }
50% {
  transform: translateY(18px) scale(1,.9) rotate(45deg) ;
  border-bottom-right-radius: 40px;
}
75% { transform: translateY(9px) rotate(67.5deg); }
100% { transform: translateY(0) rotate(90deg); }`;

const Wrapper = styled.div`
  position: absolute;
  width: 50px;
  height: 50px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -100%);
  display: flex;
  flex-direction: column;
  align-items: center;

  .box {
    width: 50px;
    height: 50px;
    background: #fff;
    animation: ${animate} 0.5s linear infinite;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 3px;
  }
  .shadow {
    width: 50px;
    height: 5px;
    background: #000;
    opacity: 0.1;
    position: absolute;
    top: 59px;
    left: 0;
    border-radius: 50%;
    animation: ${shadow} 0.5s linear infinite;
  }

  p {
    margin-top: 80px;
  }
`;

function Loader() {
  return (
    <>
      <Wrapper>
        <div className="shadow" />
        <div className="box" />
        <p>Loading...</p>
      </Wrapper>
    </>
  );
}

export default Loader;
